export enum ERoutes {
  Deposit = "/deposit",
  DepositStatus = "/deposit-status/:status",
  Withdrawal = "/withdrawal",
  PaymentRedirect = "/payment-redirect",
  NotFound = "*",
}

export enum EUrlParams {
  Theme = "theme",
  StoredDataKey = "storedDataKey",
  Language = "lang",
  CurrencyId = "currencyId",
  PaymentRouteId = "paymentRouteId",
  /**
   * @deprecated Pass `?exchange=<name>` instead — the widget resolves
   * the API URL from a per-exchange map. Kept here as a fallback so
   * legacy iframe URLs in `payments_routes.fiat_iframe_*_url` keep
   * working until they're migrated.
   */
  ApiUrl = "apiUrl",
  Exchange = "exchange",
  WalletId = "walletId",
  RedirectUrl = "redirectUrl",
}

export enum EDepositStatus {
  Success = "success",
  Cancel = "cancel",
  Error = "error",
}

export enum EMessageTypes {
  SetHeight = "setHeight",
  DepositStatusRedirect = "depositStatusRedirect",
}

export enum EWithdrawalStep {
  AmountInput = 1,
  BankSelection = 2,
  ConfirmWithdrawal = 3,
  InitiateWithdrawal = 4,
}
